import { useEffect, useState, useCallback, useMemo } from 'react';
import { PlaycastWebrtcStats } from '@playcastdotio/Peer';
import { getPeer } from '../../api/modules/peer';

const formatBitrate = (value: number) => {
  if (value >= 1000) {
    return `${(value / 1000).toFixed(1)}k`;
  }
  return `${value.toFixed(1)}`;
};

export const PlayerStats = () => {
  const [debugStats, setDebugStats] = useState({
    fps: 0,
    bitrate: 0,
    ping: 0,
  });

  const updateStats = useCallback((stats: PlaycastWebrtcStats | null) => {
    if (stats?.quality?.rawStats) {
      const newFps = stats.quality.rawStats.avgFrameRate || 0;
      const newBitrate = (stats.quality.rawStats.bitsPerSecond || 0) / 1000;
      const newPing = (stats.candidatePair?.currentRoundTripTime || 0) * 1000;

      setDebugStats((prev) => {
        if (prev.fps === newFps && prev.bitrate === newBitrate && prev.ping === newPing) {
          return prev;
        }
        return {
          fps: newFps,
          bitrate: newBitrate,
          ping: newPing,
        };
      });
    }
  }, []);

  useEffect(() => {
    const peer = getPeer();
    if (!peer) return;

    const listenerId = peer.statistics.addListener(updateStats);

    return () => {
      peer.statistics.removeListener(listenerId);
    };
  }, [updateStats]);

  const formattedBitrate = useMemo(() => formatBitrate(debugStats.bitrate), [debugStats.bitrate]);
  const formattedPing = useMemo(() => debugStats.ping.toFixed(0), [debugStats.ping]);
  const formattedFps = useMemo(() => debugStats.fps.toFixed(0), [debugStats.fps]);

  return (
    <div className='pointer-events-none absolute z-[1000] h-dvh w-full text-lg font-bold text-emerald-400'>
      <div className='absolute bottom-0 left-[30%] flex gap-2'>
        <div>{formattedPing}ms</div>
        <div>{formattedBitrate} kbps</div>
      </div>
      <div className='absolute bottom-0 left-[60%] flex'>
        <div>{formattedFps} FPS</div>
      </div>
    </div>
  );
};
